export default {
  documentTitle: '管理后台',
  id: 'ID',
  createdAt: '创建时间',
  updatedAt: '更新时间',
  new: '创建',
  detail: '详情',
  edit: '编辑',
  destroy: '删除',
  operateSuccess: '操作成功',
  testerTitleInListPage: '体验者(只显示该平台添加的)',
  suggestSize: '建议尺寸',
  profileInfo: '个人信息',
  createApplication: '新建应用',
  logout: '退出',
  choiceRole: '选择角色',
  miniProgram: '小程序',
  waitForBinding: '待绑定',
  waitForWechatAudit: '已经提交小程序注册申请, 等待微信审核',
  miniProgramRegistrationFail: '小程序注册失败，点击查看',
  yesterdayPageView: '昨日页面浏览量',
  yesterdayUserView: '昨日访客量',
  customPlan: '套餐',
  standardPlan: '标准版',
  expired: '已到期',
  expiredTime: '到期时间为',
  expiredTips: '套餐到期小程序将处于打烊状态，您将无法访问小程序请联系客服进行升级或续费。',
  contactCustomer: '联系客服',
  customerPhone: '客服电话',
  customerEmail: '客服邮箱',
  longTermEffective: '长期有效',
  visitsInTheLastWeek: '最近一周访问情况',
  pageView: '浏览量',
  userView: '访客量',
  noData: '暂无数据',
  newUserStatistics: '用户新增统计',
  usersCount: '用户量',
  membersCount: '会员量',
  userGenderDistribution: '用户性别分布',
  userGender: '用户性别',
  userTypeDistribution: '用户类型分布',
  userType: '用户类型',
  notAssociatedApplication: '当前账号没有关联任何应用',
  changePassword: '修改密码',
  currentPassword: '当前密码',
  newPassword: '新密码',
  confirmPassword: '确认密码',
  error: '错误',
  pleaseLogin: '请登录',
  verificationCodeSendSuccessfully: '验证码发送成功',
  productsCount: '酒品数量',
  postsCount: '帖子数量',
  messagesCount: '询价留言数量',
  unreadMessagesCount: '未读询价留言数量',
  count: '数量',
  unauthorized: '尚未授权',
  actions: {
    user: {
      isBlockToTrue: '冻结',
      isBlockToFalse: '解冻'
    }
  },
  menu: {
    productManagement: '酒品管理',
    merchantManagement: '酒庄管理',
    userManagement: '用户管理',
    eventManagement: '活动管理',
    pageManagement: '页面管理',
    applicationManagement: '应用管理',
    contentManagement: '内容管理',
    homePage: '首页',
    dataAnalysis: '数据统计',
  },
  login: {
    manageSystem: '管理系统',
    remenberPassword: '记住密码',
    forgetPassword: '忘记密码？',
    login: '登录',
    loginSuccess: '登录成功',
    inputEmail: '输入邮箱',
    inputPassword: '输入密码',
    confirmNewPassword: '确认密码',
    inputRucaptcha: '输入图片验证码',
    resetPassword: '重置密码',
    resetPasswordSuccess: '重置密码成功',
    sendVeirificationSuccess: '验证码已发送',
    missingLoginName: '邮箱必填',
    sendResetPasswordEmailSuccess: '重置密码邮件已发送',
    getResetPasswordEmail: '获取重置密码邮件',
    signUp: '注册',
    sendVerificationCode: '获取验证码',
    inputVerificationCode: '输入验证码',
    setPassword: '设置密码',
    signIn: '登录',
    signUpSuccess: '注册成功',
  },
  wechatMiniProgram: {
    analysis: {
      refDate: '时间',
      sessionCnt: '打开次数',
      visitPv: '访问次数',
      visitUv: '访问人数',
      visitUvNew: '新用户数',
      stayTimeUv: '人均停留时长（秒）',
      stayTimeSession: '次均停留时长（秒）',
      visitDepth: '平均访问深度',
      retentionUvNew: '新增用户数',
      retentionUvActive: '活跃用户数',
      retainedUsers: '留存用户数',
      genderAndAge: '性别及年龄',
      platformAndDevice: '终端及机型',
      portraitOfNewUsers: '新增用户数',
      portraitOfActiveUsers: '活跃用户数',
      pagePath: '页面路径',
      pageVisitPv: '访问次数',
      pageVisitUv: '访问人数',
      pageStaytimePv: '次均停留时长',
      entrypagePv: '进入页次数',
      exitpagePv: '退出页次数',
      pageSharePv: '转发次数',
      pageShareUv: '转发人数',
      retainInfo: '访问留存',
      userPortrait: '用户画像',
      accessSourceSessionCnt: '访问来源',
      accessStaytimeInfo: '访问时长',
      accessDepthInfo: '平均访问深度',
      sourceAnalysis: '来源分析',
      gender: '性别',
      age: '年龄',
      region: '地区分布',
      province: '省级分布',
      city: '地级分布',
      platform: '终端分布',
      device: '机型分布',
      yesterday: '昨天',
      latest7Day: '最近7天',
      latest30Day: '最近30天',
      time: '时间',
      daily: '日粒度',
      weekly: '周粒度',
      monthly: '月粒度',
      pleaseSelectDate: '选择日期',
      pleaseSelectWeek: '选择周',
      pleaseSelectMonth: '选择月份',
      weeklyFormat: 'yyyy 第 WW 周',
      timeDayLater: '%{value}天后',
      timeWeekLater: '%{value}周后',
      timeMonthLater: '%{value}月后',
      visitDistribution: '访问来源',
      summaryAndVisitPage: '访问页面',
      visitTrend: '访问趋势',
      visitPage: '访问页面',
      visitRetain: '访问留存',
    }
  },
  hint: {
    cannotChangeAfterCreate: '创建后不可修改',
    positionColumn: '数值越小，优先级越高',
    shareDescLengthHint: '内容长度不大于15',
  },
  model: {
    activeStorageBlob: '资源'
  },
  activeStorageBlob: {
    contentTypes: {
      image: '图片',
      video: '视频',
      audio: '音频',
      text: '文本',
      xml: 'XML',
      json: 'JSON',
      pdf: 'PDF',
      sheet: 'Sheet'
    }
  },
  customPage: {
    publish: '发布',
    preview: '预览',
    default: '预置页面'
  },
  application: {
    shareDesc: '分享描述',
    wechatOfficialAccountURL: '微信公众号链接',
    homeTopLogo: '中英文Logo',
    homeBottomLeftLogo: '英文Logo',
    questionaireTopImage: '问卷标题上方图片',
    questionaireBackgroundImage: '问卷背景图',
    personalCenterBackgroundImage: '个人中心背景图',
    myCardsBackgroundImage: '名片背景图',
    wechatApplication: {
      trialSubmition: {
        userVersion: '体验版本',
        userDesc: '体验版本描述',
        trialVersionQrcode: '体验版二维码',
      },
      onlineSubmition: {
        userVersion: '线上版本',
        userDesc: '线上版本描述',
      },
      auditSubmition: {
        userVersion: '审核版本',
        userDesc: '审核版本描述',
        state: '审核状态',
        reason: '原因',
      },
      qrcodeURL: '线上版小程序码',
    },
    actions: {
      submitAudit: '提交审核',
      simulateSubmitAudit: '模拟提交审核',
      release: '发布',
      simulateRelease: '模拟发布',
      updateExpiredAt: '到期时间设置',
      reauthorization: '重新授权',
      bindMiniProgram: '绑定小程序',
    },
  },
  page: {
    presetPage: '预置页面',
  },
  banner: {
    targetUrl: '目标链接',
    targetAppid: '目标App ID',
  },
  adminUser: {
    password: '密码',
    passwordConfirmation: '密码确认'
  }
}
